import { Flame, Dumbbell, Activity } from 'lucide-react';

interface StatsTilesProps {
  streak: number;
  trainingDaysThisWeek: number;
  setsThisWeek: number;
}

export function StatsTiles({
  streak,
  trainingDaysThisWeek,
  setsThisWeek,
}: StatsTilesProps): JSX.Element {
  return (
    <div className="grid grid-cols-3 gap-2 md:gap-3">
      <Tile
        Icon={Flame}
        iconColor="text-amber-500"
        value={String(streak)}
        unit={streak === 1 ? 'Tag' : 'Tage'}
        label="Streak"
      />
      <Tile
        Icon={Dumbbell}
        iconColor="text-emerald-600"
        value={String(trainingDaysThisWeek)}
        unit={trainingDaysThisWeek === 1 ? 'Tag' : 'Tage'}
        label="Diese Woche"
      />
      <Tile
        Icon={Activity}
        iconColor="text-zinc-700"
        value={String(setsThisWeek)}
        unit={setsThisWeek === 1 ? 'Set' : 'Sets'}
        label="Sets gesamt"
      />
    </div>
  );
}

interface TileProps {
  Icon: typeof Flame;
  iconColor: string;
  value: string;
  unit: string;
  label: string;
}

function Tile({ Icon, iconColor, value, unit, label }: TileProps): JSX.Element {
  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-3 md:p-4">
      <Icon aria-hidden="true" className={`size-5 ${iconColor}`} />
      <p className="mt-2 flex items-baseline gap-1">
        <span className="text-2xl font-semibold tabular-nums leading-none text-zinc-900">
          {value}
        </span>
        <span className="text-xs text-zinc-500">{unit}</span>
      </p>
      <p className="mt-1 text-xs font-medium text-zinc-600">{label}</p>
    </div>
  );
}
